module.exports = __webpack_public_path__ + "static/media/low_carb.bc14f807.png";